/* eslint-disable no-inner-declarations */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import 'select2/dist/js/select2.full.js';
import axios from "axios";


axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

jQuery(function() {
    let dataSelected;
    let allMarkers = [];

    var $select = jQuery(document).find('#select2-single-box');
    var $label = $select.parents('.form-group').find('label');

    $.getJSON('/api/kinto/stations', function (data) {
        $select.select2({
            placeholder: $select.data('placeholder'),
            allowClear: false,
            minimumResultsForSearch: Infinity,
            dropdownParent: jQuery('#mySelect'),
            templateResult: formatOutput,
            templateSelection: function (data) {
                if (data.id === '') {
                    return $select.data('placeholder');
                }
                var $data = jQuery(
                    '<span><strong>' + data.name + '</strong> ' + data.address + '</span>'
                );
                return $data;
            },
            "language": {
                "noResults": function(){
                    return "No se encontraron resultados";
                }
            },
            data: data,
            matcher: matchCustom
        });
    });

    function matchCustom(params, data) {
        if ($.trim(params.term) === '') {
            return data;
        }
        if (typeof data.name === 'undefined' || typeof data.address === 'undefined') {
            return null;
        }
        if (data.name.toLowerCase().indexOf(params.term.toLocaleLowerCase()) > -1 || data.address.toLowerCase().indexOf(params.term.toLocaleLowerCase()) > -1) {
            var modifiedData = $.extend({}, data, true);

            return modifiedData;
        }

        return null;

    }

    function formatOutput (optionElement) {
        var $state = jQuery(
            '<span><strong>' + optionElement.name + '</strong> ' + optionElement.address + '</span>'
        );
        return $state;
    };

    $label.on('click', function (e) {
        jQuery(this).parents('.dealer-map__search-location').find('select').trigger('focus').select2('focus');
    });


    if (jQuery('#js-map').length) {
        let map;
        let geocoder;

        const zoomInButton = jQuery('.js-map-zoom-in')[0];
        const zoomOutButton = jQuery('.js-map-zoom-out')[0];

        let dealershipInfo = jQuery('.js-map-dealership-info');
        let dealershipCloseButton = jQuery('.js-map-dealership-info-close');
        let dealershipLink = dealershipInfo.find('.js-map-dealership-link');
        let dealershipTitle = dealershipInfo.find('.js-map-dealership-title');
        let dealershipServices = dealershipInfo.find('.js-map-dealership-services');
        let dealershipHours = dealershipInfo.find('.js-map-dealership-hours');
        let dealershipAddress = dealershipInfo.find('.js-map-dealership-address');
        let dealershipGmapsLink = dealershipInfo.find('.js-map-dealership-gmaps-link');
        let dealershipWazeLink = dealershipInfo.find('.js-map-dealership-waze-link');
        let dealershipPhones = dealershipInfo.find('.js-map-dealership-phones');

        var mapStyle = [
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e3e9eb"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#738184"
                    },
                    {
                        "lightness": 25
                    },
                    {
                        "weight": 1
                    }
                ]
            }
        ];

        dealershipCloseButton.on('click', function () {
            dealershipInfo.fadeOut(400);
        });

        function initMap() {
            geocoder = new google.maps.Geocoder();
            map = new google.maps.Map(document.getElementById("js-map"), {
                center: { lat: -33.4513, lng: -70.6653 },
                styles: mapStyle,
                zoom: 8,
                disableDefaultUI: true,
            });

            // Setup the click event listener - zoomIn
            google.maps.event.addDomListener(zoomInButton, 'click', function () {
                map.setZoom(map.getZoom() + 1);
            });

            // Setup the click event listener - zoomOut
            google.maps.event.addDomListener(zoomOutButton, 'click', function () {
                map.setZoom(map.getZoom() - 1);
            });
        }

        function loadInfo(dealership) {
            dealershipLink.attr('href', dealership.url ? dealership.url : 'javascript:void(0)');

            dealershipTitle.text(dealership.name);

            dealershipHours.html('');
            if (dealership.open_hours) {
                dealershipHours.html(dealership.open_hours.replace(/(?:\r\n|\r|\n)/g, '<br>'));
            }

            dealershipAddress.text(dealership.address);

            const gmapsLink = `https://www.google.com/maps/search/?api=1&query=${dealership.address.replace(/\s/g, "%20").replace(/,/g, "%2C")}`;
            dealershipGmapsLink.attr('href', gmapsLink);

            const wazeLink = `https://waze.com/ul?q=${dealership.address.replace(/\s/g, "%20").replace(/,/g, "%2C")}`;
            dealershipWazeLink.attr('href', wazeLink);

            if (dealership.phone_numbers) {
                const phones = dealership.phone_numbers.split(/(?:\r\n|\r|\n)/g);
                dealershipPhones.html("");
                phones.forEach(function (phone, index) {
                    dealershipPhones.append("<li class='js-map-dealership-phone phones__item'></li>")
                    jQuery(dealershipPhones.find(".js-map-dealership-phone")[index]).append(`<a href='tel:${phone}' target='_blank' class='js-map-dealership-phone-link link-icon'></a>`);
                    jQuery(dealershipPhones.find(".js-map-dealership-phone-link")[index]).append(`<span class='js-map-dealership-phone-text link-icon__text'>${phone}</span>`);
                })
                dealershipPhones.parent().show();
            } else {
                dealershipPhones.parent().hide();
            }
            

            dealershipInfo.fadeIn(400);
        }

        function newLocation(dealership) {
            let marker;

            allMarkers.forEach(function (markerEl) {
                if(dealership.id == markerEl.idd) {
                    marker = markerEl;
                }
            });

           if(marker) {
                marker.setIcon(markerToyota);

                map.setZoom(17);
                map.setCenter(marker.getPosition());

                loadInfo(dealership);
            }

        }

        function clearMarkers() {
            allMarkers.forEach(function (markerEl) {
                markerEl.setIcon(markerPng);
            });
        }

        //google.maps.event.addDomListener(window, 'load', initialize);
        $select.on('select2:select', function(e) {
            clearMarkers();

            dataSelected = jQuery(this).select2('data')[0];
            newLocation(dataSelected);
        });

        $select.on('select2:unselect', function(e) {

            clearMarkers();

            map.setCenter({
                lat : -34.6158037,
                lng: -58.5033387
            });
            map.setZoom(6);
            dealershipInfo.fadeOut(400);
            jQuery(this).select2('close');
        });

        $select.on('select2:unselecting', function(e) {
            jQuery(this).data('unselecting', true);
        });
        
        $select.on('select2:open', function(e) {
            var unselecting = jQuery(this).data('unselecting');
            if(unselecting) {
                jQuery(this).select2('close');
                if(unselecting) {
                    jQuery(this).data('unselecting', false);
                } 
            }
        });


        function codeAddresses(geocoder, map, dealerships) {

            // delay between geocode requests - at the time of writing, 100 miliseconds seems to work well
            var delay = 10;

            // ====== Create map objects ======
            var bounds = new google.maps.LatLngBounds();

            // ======= Function to create a marker
            function createMarker(dealership, lat, lng) {
                var marker = new google.maps.Marker({
                    position: new google.maps.LatLng(lat, lng),
                    map: map,
                    icon: markerPng,
                    idd: dealership.id,
                });
                allMarkers.push(marker);

                google.maps.event.addListener(marker, 'click', function () {

                    clearMarkers();

                    marker.setIcon(markerToyota);
                    map.setZoom(17);
                    map.setCenter(marker.getPosition());

                    // Llenar info
                    loadInfo(dealership);
                });

                bounds.extend(marker.position);

            }

            // ======= Global variable to remind us what to do next
            var nextAddress = -1;

            // ======= Function to call the next Geocode operation when the reply comes back

            function theNext() {
                if (nextAddress < dealerships.length) {
                    setTimeout(function () {
                        var dealer = dealerships[nextAddress];
                        if(dealer !== undefined) {
                            if (dealer.lat !== null && dealer.lng !== null) {
                                createMarker(dealer, dealer.lat, dealer.lng);
                                theNext();
                            }
                        }
                    }, delay);
                    nextAddress++;
                } else {
                    // We're done. Show map bounds
                    map.fitBounds(bounds);
                }
            }

            // ======= Call that function for the first time =======
            theNext();
        }

        jQuery('.js-map-current-location').on('click', function (e) {
            e.preventDefault();
            // Try HTML5 geolocation.
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    map.setZoom(13);
                    map.panTo(pos);
                },
                    function (error) {
                        if (error.code == error.PERMISSION_DENIED) {
                            alert('Se bloqueó el acceso a geolocalización.')
                        } else {
                            alert(error.code)
                        }
                    });
            } else {
                // Browser doesn't support Geolocation
                alert('Tu navegador no soporta geolocalización.')
            }
        });

        axios.get("/api/kinto/stations")
            .then(function (response) {
                // success
                initMap();
                codeAddresses(geocoder, map, response.data);

            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed

            })

        const kinto_station_services = document.getElementById('kinto_station_services');
        const $servicesSelect = jQuery(document).find('#kinto_station_services').select2({
            minimumResultsForSearch: Infinity,
            // placeholder: 'Selecciona el servicio Kinto',
        });

        $servicesSelect.on('select2:select', function(e) {
            const selectedService = e.currentTarget.value;

            dealershipCloseButton.trigger('click');

            axios.get("/api/kinto/stations")
            .then(function (response) {
                // success
                initMap();
                let dealerships = response.data;
                if (selectedService !== 'todas') {
                    dealerships = dealerships.filter(d => d[selectedService] === true);
                    codeAddresses(geocoder, map, dealerships);
                    $select.empty().select2({
                        placeholder: $select.data('placeholder'),
                        allowClear: false,
                        minimumResultsForSearch: Infinity,
                        dropdownParent: jQuery('#mySelect'),
                        templateResult: formatOutput,
                        templateSelection: function (data) {
                            if (data.id === '') {
                                return $select.data('placeholder');
                            }
                            var $data = jQuery(
                                '<span><strong>' + data.name + '</strong> ' + data.address + '</span>'
                            );
                            return $data;
                        },
                        "language": {
                            "noResults": function(){
                                return "No se encontraron resultados";
                            }
                        },
                        data: dealerships,
                        matcher: matchCustom
                    }).val(null).trigger('change');
                    
                } else {
                    codeAddresses(geocoder, map, dealerships);
                    $select.empty().select2({
                        placeholder: $select.data('placeholder'),
                        allowClear: true,
                        minimumResultsForSearch: Infinity,
                        dropdownParent: jQuery('#mySelect'),
                        templateResult: formatOutput,
                        templateSelection: function (data) {
                            if (data.id === '') {
                                return $select.data('placeholder');
                            }
                            var $data = jQuery(
                                '<span><strong>' + data.name + '</strong> ' + data.address + '</span>'
                            );
                            return $data;
                        },
                        "language": {
                            "noResults": function(){
                                return "No se encontraron resultados";
                            }
                        },
                        data: dealerships,
                        matcher: matchCustom
                    }).val(null).trigger('change');
                }
                

            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed

            })
        })

    }

});
